export enum PensionAmountField {
  VESTED_RESERVE,
  ESTIVMATED_PENSION_RESERVE,
  ESTIMATED_PENSION_INCOME,
}
